export enum SkuConstraintFormat {
    Numeric = "numeric"
}